"use client"

import { Component } from "react"
import routes from "../../routes/URL"
import API, { URL_PATH } from "../../services/API"
import redux from "../../common/Redux"
import Table from "../../components/Table"
import Header from "../../components/Header"
import { getCurrency } from "../../common/util"
import Toast from "../../components/Toast"
import ConfirmationModal from "../../components/ConfirmationModal"
import axios from "axios"

import vegIcon from "../../assets/veg.svg"
import nonVegIcon from "../../assets/nonveg.svg"
import jainIcon from "../../assets/Jain.png"
import eggIcon from "../../assets/Egg.png"
import Drinks from "../../assets/Drinks.png"

const ColorScheme = {
  buttonColor: "#FFC857",
  bgColor: "#02111B",
  componentColor: "#07070A",
  accentColor: "#BB0A21", 
}



class ListMenuScreen extends Component {
   
  constructor(props) {
    super(props)
    this.state = {
      data: [],
      version: 0,
      selectedRows: [],
      isBulkDeleteConfirmationModalOpen: false,
      toast: {
        open: false,
        message: "",
        severity: "success",
      },
      

    }
  }

  showToast = (message, severity) => {
    this.setState({
      toast: {
        open: true,
        message,
        severity,
      },
    })
  }

  handleCloseToast = (event, reason) => {
    if (reason === "clickaway") {
      return
    }
    this.setState({
      toast: {
        ...this.state.toast,
        open: false,
      },
    })
  }

  onDelete = async (item) => {
    console.log("sure to delete?")
    const { status, message, data } = await API(this, "post", URL_PATH.deleteMenu(item.id))
    if (status == "success") {
      this.showToast(message, "success")
      this.setState({
        version: this.state.version + 1,
      })
    } else {
      this.showToast(message || "An error occurred", "error")
    }
  }

onEdit = async (item) => {
    this.props.history.push(routes.admin.menu.update( this.props.hotels[0].hotel_slug,item.category_slug, item.menu_slug,item.id))
  }

  onView = async (item) => {
    // this.props.history.push("/floors/" + item.id);
  }

  onSwitch = async (item, value) => {
    console.log("Switch: ", item, value)
    const { status, message, data } = await API(this, "get", URL_PATH.updateMenuStatus, {
      menu_id: item.id,
      status: value,
    })
  }

   componentDidMount() {
      // Check if hotel slug matches
      const hotel = this.props.hotels.find(h => h.hotel_slug === this.props.match.params.hotelSlug);
      if (!hotel) {
          this.props.history.push(routes.admin.dashboard.root(this.props.hotels[0]?.hotel_slug || ''));
          return;
      }
  
     
  }

  // Helper function to capitalize the first letter
  capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1)
  }

  // Handle selected rows change from Table component
  handleSelectedRowsChange = (selectedRows) => {
    this.setState({ selectedRows })
  }

  // Open bulk delete confirmation modal
  openBulkDeleteConfirmationModal = () => {
    this.setState({ isBulkDeleteConfirmationModalOpen: true })
  }

  // Close bulk delete confirmation modal
  closeBulkDeleteConfirmationModal = () => {
    this.setState({ isBulkDeleteConfirmationModalOpen: false })
  }

  // Handle bulk delete confirmation
  handleBulkDeleteConfirmation = async () => {
    await this.onBulkAction(this.state.selectedRows)
    this.closeBulkDeleteConfirmationModal()
  }

  // Bulk delete action
    onBulkAction = async (rows) => {
      const ids = Object.values(rows)
      const token = localStorage.getItem("token")
      
      const { status, message, data } = await API(this, "post", URL_PATH.deleteBulkMenu(this.props.selectedHotelId.id),{ids})
      if (status) {
        this.showToast(message, "success")
      this.setState({
            version: this.state.version + 1,
            selectedRows: [],
          })
      } else {
        this.showToast(message, "error")
      }
  
    }


  render() {
    const { selectedRows, isBulkDeleteConfirmationModalOpen } = this.state

    return (
      <div className="container-fluid">
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            alignContent: "center",
          }} 
        >
          <Header title="Menu Items" />
          <div>
            {selectedRows.length > 0 && (
              <button
                className="btn mr-2"
                style={{
                  backgroundColor: ColorScheme.accentColor,
                  color: ColorScheme.textColor,
                  marginRight: "10px",
                }}
                onClick={this.openBulkDeleteConfirmationModal}
              >
                <i className="fa fa-trash mr-1" aria-hidden="true"></i> Delete Selected ({selectedRows.length})
              </button>
            )}
            {/* <div
              className="btn mr-2"
              style={{ backgroundColor: "#0d6efd", color: "#ffffff", fontWeight: "600" }}
              onClick={() => {
                this.props.history.push(routes.admin.category.root)
              }}
            >
              <i className="fa fa-eye" aria-hidden="true"></i> View Categories
            </div> */}
            <div
              className="btn  ml-2"
              style={{ marginLeft: "10px", backgroundColor: "#FFC857", color: "#000", fontWeight: "700" }}
              onClick={() => {
    this.props.history.push(routes.admin.menu.create(this.props.hotels[0].hotel_slug))
              }}
            >
              + Add Menu
            </div>
          </div>
        </div>

        <Table
          key={this.state.version}
          api={URL_PATH.listMenu(this.props.selectedHotelId.id)}
          onRowClick={this.onView}
          onEdit={this.props.accessControl.includes("hotel-menu") ? this.onEdit : null}
          deleteText="delete all data related to this table."
          searchPlaceholder="Search by menu"

          onDelete={this.props.accessControl.includes("hotel-menu") ? this.onDelete : null}
          onSelectedRowsChange={this.handleSelectedRowsChange}
          selectedHotelId={this.props.selectedHotelId}
          row={[
  {
    title: "Icon",
    key: "menu_image",
    sortable: false,
    type: "icon",
  },
  {
    title: "Name",
    key: "menu_name",
    sortable: true,
  },
  {
    title: "Type",
    key: "menu_type",
    sortable: true,
    parse: (item) => {
      const type = item.menu_type.toLowerCase();
      let displayText = "";
      let icon = null;

      if (type.includes("nonveg")) {
        displayText = "NON-VEG";
        icon = <img src={nonVegIcon} alt="Non-Veg" style={{ width: "20px", marginRight: "8px" }} />;
      } else if (type.includes("veg")) {
        displayText = "VEG";
        icon = <img src={vegIcon} alt="Veg" style={{ width: "20px", marginRight: "8px" }} />;
      } else if (type.includes("jain")) {
        displayText = "JAIN";
        icon = <img src={jainIcon} alt="Jain" style={{ width: "20px", marginRight: "8px" }} />;
      } else if (type.includes("egg")) {
        displayText = "EGG";
        icon = <img src={eggIcon} alt="Egg" style={{ width: "20px", marginRight: "8px" }} />;
      } else if (type.includes("drinks")) {
        displayText = "DRINKS";
        icon = <img src={Drinks} alt="Drinks" style={{ width: "20px", marginRight: "8px" }} />;
      } else {
        displayText = type
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toUpperCase())
          .join(" ");
      }

      return <div style={{ display: "flex", alignItems: "center" }}>{icon}{displayText}</div>;
    },
  },
  {
    title: "Price",
    key: "menu_price",
    sortable: true,
    parse: (item) => `${getCurrency(this.props.selectedHotelId.currency)} ${item.menu_price}`,
  },
  {
    title: "Available",
    key: "status",
    sortable: true,
    type: "switch",
    onSwitch: this.onSwitch,
  },
// {
//   title: "Total Quantity Sold",
//   key: "total_quantity_sale",
//   sortable: false,
//   parse: (item) => item.total_quantity_sale ?? "N/A",
// },
// {
//   title: "Total Sales Amount",
//   key: "total_sales_amount",
//   sortable: false,
//   parse: (item) => `${getCurrency(this.props.selectedHotelId.currency)} ${item.total_sales_amount ?? 0}`,
// },

]}

        />

        {/* Bulk Delete Confirmation Modal */}
        <ConfirmationModal
          isOpen={isBulkDeleteConfirmationModalOpen}
          onConfirm={this.handleBulkDeleteConfirmation}
          onCancel={this.closeBulkDeleteConfirmationModal}
          title="Confirm Bulk Deletion"
          message={`Are you sure you want to delete the selected ${selectedRows.length} items?`}
          confirmText="Yes, delete them!"
          cancelText="Cancel"
        />

        <Toast
          open={this.state.toast.open}
          message={this.state.toast.message}
          severity={this.state.toast.severity}
          handleClose={this.handleCloseToast}
        />
      </div>
    )
  }
}

export default redux(ListMenuScreen)
